import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import ValidateAccess from '../access/ValidateAccess';
import NoAccess from '../access/NoAccess';
import { isBoolean } from '../helpers/ObjectHelpers';
import { isLoggedIn } from '../helpers/AuthHelpers';
import { RouteGuardStates } from '../../services/SystemNames';
import { useMinWidthRequired } from '../hooks/useMinWidthRequired';
import { MinWidthRequired } from '../access/MinWidthRequired';
import { ApplicationRightService } from 'services/ApplicationRightService';
import { ApplicationRightSystemNames } from '../constants/ApplicationRightSystemNames';
import Login from '../access/Login';
import { useApplicationRights } from "components/hooks/useAppStore";

export const RouteGuardDefault = ({
    children,
    beta = false,
    minWidth,
}) => {

    const location = useLocation();
    const [guardState, setGuardState] = useState(RouteGuardStates.Busy);
    const hasMinWidth = useMinWidthRequired(minWidth, true);

    const applicationRights = useApplicationRights();

    useEffect(() => {
        if (!applicationRights) return;

        let flag = true

        const applicationRightService = new ApplicationRightService(applicationRights);
        const canAccessPilotWeb = applicationRightService.canAccess([ApplicationRightSystemNames.NJORD_PILOT_WEB_LOGIN]);

        if (isBoolean(beta)) {
            if (beta) {
                flag = applicationRightService.canAccess([ApplicationRightSystemNames.ACCESS_TO_BETA_PROGRAM]);
            }
        }

        setGuardState((flag && isLoggedIn() && canAccessPilotWeb) ? RouteGuardStates.Valid : RouteGuardStates.Login);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, applicationRights])

    return (
        hasMinWidth ?
            (() => {
                switch (guardState) {
                    case RouteGuardStates.Valid:
                        return (children);
                    case RouteGuardStates.NoAccess:
                        return (<NoAccess />);
                    case RouteGuardStates.Login:
                        return (<Login />);
                    default:
                        return (<ValidateAccess />);
                }
            })()
            :
            <MinWidthRequired minWidth={minWidth} />
    )

};
